import { useQuery } from "@tanstack/react-query";
import useApi from "../utils/useApi";

export default function useExistsDaysWithoutSchedule() {
  const { existsDaysWithoutSchedule } = useApi();

  const { data, isLoading } = useQuery({
    queryKey: ["existsScheduleWithoutDays"],
    queryFn: () => existsDaysWithoutSchedule({ storeId: 1 }),
  });

  const existsScheduleWithoutDays = data?.data.exists_days_without_schedule;

  return { data: existsScheduleWithoutDays, isLoading };
}
